module.exports = __webpack_public_path__ + "img/img4zhounq-1.79301c7d.png";